import { useEffect } from "react";
import { toast } from "react-toastify";
import { isElectron } from "../platform";
import { consumePendingDesktopAuthError } from "../platform/desktopIntegration";

const UPDATE_TOAST_ID = "orderly-update-status";

const installAction = () => (
  <span>
    Update ready.{" "}
    <button type="button" onClick={() => void window.electronAPI.updates.install()}>
      Restart now
    </button>
  </span>
);

const showStatus = (status) => {
  if (status.state === "available") {
    toast.info(
      <span>
        Orderly {status.version} is available.{" "}
        <button type="button" onClick={() => void window.electronAPI.updates.download()}>
          Download
        </button>
      </span>,
      { toastId: UPDATE_TOAST_ID, autoClose: false }
    );
  } else if (status.state === "downloading") {
    if (!toast.isActive(UPDATE_TOAST_ID)) {
      toast.loading("Downloading update…", { toastId: UPDATE_TOAST_ID });
    }
    toast.update(UPDATE_TOAST_ID, {
      render: `Downloading update… ${status.percent ?? 0}%`,
      isLoading: true,
      autoClose: false
    });
  } else if (status.state === "downloaded") {
    if (toast.isActive(UPDATE_TOAST_ID)) {
      toast.update(UPDATE_TOAST_ID, {
        render: installAction(),
        type: "success",
        isLoading: false,
        autoClose: false
      });
    } else {
      toast.success(installAction(), { toastId: UPDATE_TOAST_ID, autoClose: false });
    }
  } else if (status.state === "error") {
    if (toast.isActive(UPDATE_TOAST_ID)) toast.dismiss(UPDATE_TOAST_ID);
    toast.error(status.message || "The update service is unavailable", {
      toastId: UPDATE_TOAST_ID
    });
  }
};

export default function DesktopUpdateStatus() {
  useEffect(() => {
    if (!isElectron()) return undefined;

    const unsubscribeUpdates = window.electronAPI.updates.onStatus(showStatus);
    void window.electronAPI.updates.getStatus().then(showStatus).catch((error) => {
      console.error("Unable to read the desktop update status", error);
    });

    const authError = (event) => {
      consumePendingDesktopAuthError();
      toast.error(event.detail?.message || "Sign-in failed");
    };
    window.addEventListener("orderly:auth-error", authError);
    const pendingAuthError = consumePendingDesktopAuthError();
    if (pendingAuthError) toast.error(pendingAuthError);
    return () => {
      unsubscribeUpdates();
      window.removeEventListener("orderly:auth-error", authError);
    };
  }, []);

  return null;
}
